export default __webpack_public_path__ + "static/catalog-d6740356d3f91ec18d50c83e0d7af6d0.gif";